module.exports = __webpack_public_path__ + "r-v3/img/question.ab759b82.svg";